import React, {Component} from 'react';
import {Route, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import ComponentDictionary from '../ComponentDictionary';
import TermsAndConditions from '../TermsAndConditions';
class RoutesComponent extends Component {
    constructor(props) {
        super(props);
        this.key = 0;
        this.mapRoutes = this.mapRoutes.bind(this);
    }

    mapRoutes(key) {
    
        this.key++;
        if(key.subRoutes) {
            this.key++;
            return key.subRoutes.map(this.mapRoutes)
        }else{
            this.key++;
            return <Route key={this.key} exact path={key.url} component={ComponentDictionary[key.component]} />
        }
    }

    render() {

        return (
            <div>
                { this.props.user ? this.props.user.user_profile ? this.props.user.user_profile.accepted_terms ? this.props.user.user_profile.accepted_terms === '0' ? this.props.location.pathname != '/terms-and-conditions' ?  <Route render={() => <Redirect to="/terms-and-conditions"/>} /> : null : null : null : null : null}
                { this.props.user ? this.props.user.user_profile ? this.props.user.user_profile.accepted_terms ? this.props.user.user_profile.accepted_terms === '1' ? this.props.location.pathname == '/terms-and-conditions' ?  <Route render={() => <Redirect to="/"/>} /> : null : null : null : null : null}
                <Route key={'terms-and-conditions'} exact path="/terms-and-conditions" component={TermsAndConditions} />
                {this.props.user.profileRoutes ? this.props.user.profileRoutes.map(this.mapRoutes) : ''}
                {this.props.user.availableRoutes ? this.props.user.availableRoutes.map(this.mapRoutes) : ''}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
    }
}


export default withRouter(connect(mapStateToProps)(RoutesComponent));



// WEBPACK FOOTER //
// ./src/components/Application/Routes/index.js